import { useEffect, useRef } from 'react';

interface StatItem {
  target: number;
  suffix: string;
  label: string;
}

const STATS: StatItem[] = [
  { target: 50,  suffix: '+', label: 'Zákazníkov'  },
  { target: 7,   suffix: '',  label: 'Dní delivery' },
  { target: 100, suffix: '%', label: 'Spokojnosť'  },
  { target: 10,  suffix: '+', label: 'Rokov v IT'  },
];

function countUp(el: HTMLSpanElement, target: number) {
  const duration = 1800;
  const step = 16;
  const increment = target / (duration / step);
  let current = 0;
  const timer = setInterval(() => {
    current = Math.min(current + increment, target);
    el.textContent = String(Math.floor(current));
    if (current >= target) clearInterval(timer);
  }, step);
}

export default function Stats() {
  const counterRefs = useRef<(HTMLSpanElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const el = e.target as HTMLSpanElement;
            if (el.dataset.animated) return;
            el.dataset.animated = 'true';
            el.textContent = '0';
            countUp(el, Number(el.dataset.target));
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    counterRefs.current.forEach((el) => { if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, []);

  return (
    <section id="stats" aria-label="Štatistiky">
      <div className="container">
        <div className="stats-grid">
          {STATS.map((s, i) => (
            <div key={s.label} className={`stat-item fade-up${i > 0 ? ` delay-${i}` : ''}`}>
              <div className="stat-num">
                <span
                  ref={(el) => { counterRefs.current[i] = el; }}
                  className="counter"
                  data-target={s.target}
                >
                  {s.target}
                </span>
                {s.suffix && <span className="accent-num">{s.suffix}</span>}
              </div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
